
export const name = "website-grader-ui";
export const version = "dev";
